(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vivier-carousel-block"] && !Shopify.designMode) return;
  try {
    class VivierCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vivier-carousel-track]');
      this.prevButton = this.querySelector('[data-vivier-carousel-prev]');
      this.nextButton = this.querySelector('[data-vivier-carousel-next]');
      this.isDragging = false;
      this.hasDragged = false;
      this.dragStartX = 0;
      this.dragStartScrollLeft = 0;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByAmount(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByAmount(1));
      }
      if (this.track) {
        this.track.addEventListener('scroll', () => this.updateButtonStates());
        window.addEventListener('resize', () => this.updateButtonStates());

        // Native overflow-x: auto only responds to touch and trackpad
        // gestures, not mouse click-and-drag. Add drag-to-scroll for
        // mouse/pen input only; touch keeps using native scrolling so the
        // two input paths don't conflict with each other.
        //
        // Deliberately NOT using setPointerCapture here: capturing the
        // pointer on the track retargets the resulting click event away
        // from the underlying product link, which silently breaks normal
        // (non-drag) clicks on every card, not just dragged ones. Tracking
        // movement via window-level listeners avoids that entirely.
        this.track.addEventListener('pointerdown', (e) => this.onPointerDown(e));

        // If a drag occurred, suppress the click that would otherwise
        // navigate via a card's full-card link overlay.
        this.track.addEventListener(
          'click',
          (e) => {
            if (this.hasDragged) {
              e.preventDefault();
              e.stopPropagation();
              this.hasDragged = false;
            }
          },
          true
        );
      }

      this.updateButtonStates();
    }

    onPointerDown(e) {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      this.isDragging = true;
      this.hasDragged = false;
      this.dragStartX = e.clientX;
      this.dragStartScrollLeft = this.track.scrollLeft;
      this.track.classList.add('vivier-carousel__track--dragging');

      this.boundPointerMove = (event) => this.onPointerMove(event);
      this.boundPointerUp = (event) => this.onPointerUp(event);
      window.addEventListener('pointermove', this.boundPointerMove);
      window.addEventListener('pointerup', this.boundPointerUp);
      window.addEventListener('pointercancel', this.boundPointerUp);
    }

    onPointerMove(e) {
      if (!this.isDragging) return;
      const deltaX = e.clientX - this.dragStartX;
      if (Math.abs(deltaX) > 5) {
        this.hasDragged = true;
      }
      this.track.scrollLeft = this.dragStartScrollLeft - deltaX;
    }

    onPointerUp() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('vivier-carousel__track--dragging');
      window.removeEventListener('pointermove', this.boundPointerMove);
      window.removeEventListener('pointerup', this.boundPointerUp);
      window.removeEventListener('pointercancel', this.boundPointerUp);
    }

    scrollByAmount(direction) {
      if (!this.track) return;
      const firstSlide = this.track.children[0];
      const slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      this.track.scrollBy({ left: direction * (slideWidth + gap), behavior: 'smooth' });
    }

    updateButtonStates() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
      }
    }
  }

  customElements.define('vivier-carousel', VivierCarousel);
  } catch(e) { console.error(e); }
})();

})();
